import React, { Component } from "react";
import "./education.css";
import { useParams } from 'react-router-dom';
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
import Page from "../../components/page/page";
import { getEducationById } from "../../constants/education-constants";

function EducationDetail() {

    const params = useParams();
    const education = [...getEducationById(params.id)];
    console.log("params.id : ", params.id);
    console.log("education : ", education);
    return (
        <Page>
            <Header />
            <section className="container news-content">
                <div className=" row hrow ">
                    <figure className="figure">
                        <img src={`${education[0].imageUrl}`}  className="figure-img img-fluid " alt="..." />
                        <figcaption className="figure-caption">
                            <h3>
                                {education[0].title}
                            </h3>
                            <span className="time">{education[0].location}</span>
                        </figcaption>
                    </figure>
                </div>
                <p className="hy-text-body">
                    {education[0].description}
                </p>
                <div className="gray_container">
                    <h5 className="mb-4">سرفصل دوره آموزشی</h5>
                    <ul className="list-unstyled">
                        {education[0].headlines.map(element => (
                            <li className="mb-3" key={element.key}>{element.value}</li>
                        ))}
                    </ul>
                </div>
                <p className="hy-text-body">
                    {education[0].extraDetailP1}
                </p>
                <p className="hy-text-body">
                    {education[0].extraDetailP2}
                </p>
            </section>
            <Footer />
        </Page >
    );
}


export default EducationDetail;